<template>
  <context-menu-icon v-if="notification.status !== 'HANDLED'">
    <v-list dense>
      <v-list-item @click="setNotificationHandled(notification.id)">
        <v-list-item-icon><v-icon small>{{ 'mdi-check-circle'}}</v-icon></v-list-item-icon>
        <v-list-item-title>{{ trans('notifications.setHandled') }}</v-list-item-title>
      </v-list-item>
      <template v-if="notification.status === 'ACTIVE'">
        <v-divider></v-divider>
        <template v-for="(silentUntilPreset, i) in silentUntilPresets">
          <v-list-item
            :key="'silentUntilPreset-' + i"
            @click="setNotificationSilentUntil(notification.id, getDateIn(...silentUntilPreset))"
          >
            <v-list-item-icon><v-icon small>{{ 'mdi-bell-off'}}</v-icon></v-list-item-icon>
            <v-list-item-title>{{ trans('notifications.setSilentUntilFor') }} {{ getDateIn(...silentUntilPreset).fromNow() }}</v-list-item-title>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </context-menu-icon>
</template>

<script>
import {NotificationUtils} from '@/utils/notification-utils';
import ContextMenuIcon from '@/components/ContextMenuIcon';
import {LocaleUtils} from '@/utils/locale-utils';
import dayjs from 'dayjs';

export default {
  name: 'NotificationContextMenu',
  mixins: [
    NotificationUtils,
    LocaleUtils
  ],
  components: {
    ContextMenuIcon
  },
  props: {
    /** @type {NotificationDto} */
    notification: {
      required: true
    }
  },
  methods: {
    getDateIn (...args) {
      return dayjs().add(...args);
    }
  },
  computed: {
    silentUntilPresets () {
      return [
        [1, 'hour'],
        [1, 'day'],
        [3, 'day'],
        [7, 'day'],
      ];
    }
  }
}
</script>

<style scoped>

</style>
